"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _styles = require("@material-ui/core/styles");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    noResults: {
      height: 'auto',
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(1)
    }
  };
});
var NoResultsOption = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var classes = useStyles();
  var componentProps = props.componentProps,
    commonProps = props.commonProps;
  var automationid = commonProps.automationid,
    dataMetrics = commonProps.dataMetrics;
  var text = componentProps.text;
  return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
    automationid: "".concat(automationid, "-no-results-option"),
    className: classes.noResults,
    component: "div",
    "data-metrics": dataMetrics.noResultsOption,
    disabled: true,
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    noWrap: true,
    variant: "body1"
  }, text));
});
NoResultsOption.propTypes = process.env.NODE_ENV !== "production" ? {
  commonProps: _propTypes["default"].object,
  componentProps: _propTypes["default"].object
} : {};
var _default = NoResultsOption;
exports["default"] = _default;